import React, { FC, useState } from 'react';
import { AD_SIZE_RESPONSIVE_MAPPING, AD_SIZE_SMALL, AdUnit } from './ad.consts';
import { AdSlot } from 'react-dfp';
import { allowAds } from 'logic/cookies/GDPR';
import styled from 'styled-components';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Text } from 'components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';

export type AdProps = {
  adUnit: AdUnit;
  size?: number[];
  style?: any;
};

export const Ad: FC<AdProps> = ({ style, adUnit, size }) => {
  const [loaded, setLoaded] = useState(false);

  const isResponsive = !size;
  return allowAds ? (
    <AdContainer style={style}>
      <div>
        <Text size={12}>{loaded && translate(translationKeys.common.ad)}</Text>
        <AdSlot
          adUnit={adUnit}
          sizes={[size || AD_SIZE_SMALL]}
          sizeMapping={isResponsive ? AD_SIZE_RESPONSIVE_MAPPING : undefined}
          onSlotRender={(eventData: any) => {
            if (!eventData?.event?.isEmpty) {
              setLoaded(true);
            }
          }}
        />
      </div>
    </AdContainer>
  ) : null;
};

export const AdContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const SearchResultsSideBarAds = () => (
  <>
    <Ad adUnit={'web_searchresults_sidebar'} size={AD_SIZE_SMALL} style={{ marginTop: '-15px' }} />
    <Ad adUnit={'web_searchresults_sidebar'} size={AD_SIZE_SMALL} style={{ marginTop: '-6px' }} />
    <Ad adUnit={'web_searchresults_sidebar'} size={AD_SIZE_SMALL} style={{ marginTop: '-6px' }} />
  </>
);

export const SearchResultsTopAd = () => {
  const { minTablet } = useBreakpoints();

  return minTablet ? (
    <Ad adUnit={'web_searchresults_top_banner'} style={{ marginTop: '30px' }} />
  ) : null;
};

export const SearchResultsBottomAd = () => (
  <Ad adUnit={'web_searchresults_banner_bottom'} style={{ marginBottom: '90px' }} />
);
